<template>
  <div style="zoom:0.9;">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("aggregator", 1) }}
      </div>
      <router-link class="btn-blue" to="/user-management/aggregator-users"
        >{{ $tc("aggregator", 1) }} {{ $tc("user", 2) }}
        {{ $tc("list", 1) }}</router-link
      >
    </div>
    <div class="white-wrapper my-3">
      <form class="row my-3">
        <section v-if="true" class="mb-4 w-100 px-3 section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-collapse-box new-border"
            style="padding: 6px; align-items: center; border-radius: 10px"
            v-b-toggle.personalDetails
          >
            <span class="fs">
              {{ $tc("Personal Details", 2) }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="personalDetails"
            class="mt-2"
            v-model="sectionCollapse.personalDetails"
          >
            <div
              class="row pr-2 pl-2 pt-3 pb-2 br-10 mx-auto back"
              style="border-radius: 10px"
            >
              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      type="text"
                      v-model="userDetails.first_name"
                      name="firstname"
                      id="firstname"
                      v-validate="'required|alpha_spaces'"
                    />
                    <label>{{ $t("name") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_NameTooltip')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('firstname')">{{
                    errors.first("firstname")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      type="text"
                      v-model="userDetails.middle_name"
                      name="middlename"
                      id="middlename"
                    />
                    <label>{{ $t("middlename") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_MiddleName')" /> -->
                </div>
                <!-- <p
                    v-if="submitted && errors.has('middlename')"
                    class="error_message"
                  >{{ errors.first('middlename') }}</p>-->
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.last_name"
                      type="text"
                      name="lastname"
                      id="lastname"
                      v-validate="'required|alpha_spaces'"
                    />
                    <label>{{ $t("lastname") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_LastName')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('lastname')">{{
                    errors.first("lastname")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.up_address1"
                      type="text"
                      name="address"
                      id="address"
                      v-validate="'required'"
                    />
                    <!-- v-validate="'required|regex: /^[_]*$/|alpha_dash|alpha_num|alpha_spaces'" -->
                    <label>{{ $t("address") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Address')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('address')">{{
                    errors.first("address")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Country && selected.Country.length > 0
                          ? 'shift-up'
                          : ''
                      "
                    >
                      {{ $tc("country", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.Country"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Country"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCountry($event.target.value)"
                          v-on:keydown="onSearchCountry($event.target.value)"
                          v-model="searchCountry"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(country, countryIndex) in Countries"
                        :key="countryIndex"
                        v-on:click="onSelectHandler('country', country)"
                        name="selectcountry"
                        id="selectcountry"
                        >{{ country.country_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Country')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.State && selected.State.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("state", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.State"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search State"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchState($event.target.value)"
                          v-on:keydown="onSearchState($event.target.value)"
                          v-model="searchState"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(state, stateIndex) in States"
                        :key="stateIndex"
                        @click="onSelectHandler('state', state)"
                        name="selectstate"
                        id="selectstate"
                        >{{ state.state_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_State')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.City && selected.City.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("city", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.City"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search City"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCity($event.target.value)"
                          v-on:keydown="onSearchCity($event.target.value)"
                          v-model="searchCity"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(city, cityIndex) in Cities"
                        :key="cityIndex"
                        @click="onSelectHandler('city', city)"
                        name="selectcity"
                        id="selectcity"
                        >{{ city.city_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Cities')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.zipcode"
                      type="text"
                      name="zipcode"
                      id="zipcode"
                      v-validate="'alpha_num'"
                    />
                    <label>{{ $t("zipcode") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_ZipCode')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.AggregatorType &&
                        selected.AggregatorType.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("aggregator", 1) }} {{ $tc("type", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.AggregatorType"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(aggregator, aggregatorIndex) in aggregatorType"
                        :key="aggregatorIndex"
                        @click="onSelectHandler('aggregatorType', aggregator)"
                        name="selectstate"
                        id="selectstate"
                        >{{ aggregator }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_State')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.email_id"
                      type="email"
                      name="email_id"
                      id="email_id"
                      v-validate="'required|email'"
                    />
                    <!-- bcoz  v-validate="'required|email'" -->
                    <label>{{ $t("emailid") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_EmailId')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('email_id')">{{
                    errors.first("email_id")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.up_alt_contact_no"
                      type="text"
                      name="phoneno"
                      id="phoneno"
                      v-validate="'numeric|min:7'"
                    />
                    <label>{{ $t("phone") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_phone')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('phoneno')">{{
                    errors.first("phoneno")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material row">
                    <div class="col-4">
                      <b-dropdown
                        :text="
                          userDetails.country_mob_code
                            ? userDetails.country_mob_code
                            : 'Code'
                        "
                        variant="dropdown-curve"
                        class="w-100 text-center mr-3"
                        placeholder="code"
                        name="countrycode"
                        id="countrycode"
                      >
                        <div class="px-2 pb-2">
                          <input
                            required
                            autofocus
                            type="search"
                            placeholder="Search Code"
                            class="form-control form-control-sm"
                            v-on:keyup="onSearchCode($event.target.value)"
                            v-on:keydown="onSearchCode($event.target.value)"
                            v-on:search="onSearchCode($event.target.value)"
                            v-model="searchCode"
                          />
                        </div>
                        <b-dropdown-item
                          href="#"
                          v-for="(countrycode, countryIndex) in countryList"
                          :key="countryIndex"
                          v-on:click="
                            onSelectHandler('countrycode', countrycode)
                          "
                          v-if="countrycode.country_mob_code != null"
                          >{{ countrycode.country_mob_code }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                    <div class="col-8 pl-1">
                      <input
                        placeholder="."
                        v-model="userDetails.mobile_no"
                        type="text"
                        name="mobileno"
                        id="monileno"
                        v-validate="'required|numeric|min:8|max:14'"
                      />
                      <label>{{ $t("mobiles") }}</label>
                    </div>
                  </div>
                  <!-- <Tooltip :title="$t('user_mobile')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && !userDetails.country_mob_code">{{
                    "Country Code Required."
                  }}</span>
                  <span>{{ " " }}</span>
                  <span v-if="submitted && errors.has('mobileno')">{{
                    errors.first("mobileno")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.report_code"
                      type="text"
                      name="report_code"
                      id="report_code"
                    />
                    <label>{{ "Report Code" }}</label>
                  </div>
                </div>
                <p class="error_message"> </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.gl_account"
                      type="text"
                      name="gl_account"
                      id="gl_account"
                    />
                    <label>{{ "GL Account" }}</label>
                  </div>
                </div>
                <p class="error_message"> </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.gl_desc"
                      type="text"
                      name="gl_desc"
                      id="gl_desc"
                    />
                    <label>{{ "GL Description" }}</label>
                  </div>
                </div>
                <p class="error_message"> </p>
              </div>

              <div
                class="col-2 align-self-center mb-3"
                v-if="showKitchenOrderFields"
              >
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.kitchen_color_code"
                      type="color"
                      name="kitchen_color_code"
                      id="kitchen_color_code"
                    />
                    <label>{{ "Kitchen Color Code" }}</label>
                  </div>
                </div>
                <p class="error_message"> </p>
              </div>

              <div
                class="col-2 align-self-center mb-3"
                v-if="showKitchenOrderFields"
              >
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.kitchen_order_seq"
                      type="number"
                      name="kitchen_order_seq"
                      id="kitchen_order_seq"
                    />
                    <label>{{ "Order Seq" }}</label>
                  </div>
                </div>
                <p class="error_message"> </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <label class="mb-0 mr-3"
                    >Is {{ $t("online_fee") }} fee applied</label
                  >
                  <b-form-checkbox
                    :unchecked-value="'N'"
                    :value="'Y'"
                    v-model="userDetails.is_internet_handling_fee_applied"
                    name="check-button-internethandling-fee"
                    class="j-checkbox mr-2"
                    switch
                  ></b-form-checkbox>
                </div>
                <p class="error_message"></p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <label class="mb-0 mr-3">Direct Payment Allowed</label>
                  <b-form-checkbox
                    :unchecked-value="'N'"
                    :value="'Y'"
                    v-model="userDetails.is_direct_payment_allowed"
                    name="check-button-is-direct-payment-allowed"
                    class="j-checkbox mr-2"
                    switch
                  ></b-form-checkbox>
                </div>
                <p class="error_message"></p>
              </div>

              <div
                v-if="!(this.affectedUserId == this.editorUser)"
                class="col-lg-6 col-xl-4 align-self-center mb-3"
              >
                <div class="d-flex align-items-center">
                  <label class="mb-0 mr-3">{{ $t("active") }}</label>
                  <label class="j-checkbox mb-0">
                    <b-form-checkbox
                      v-model="userDetails.is_active"
                      type="checkbox"
                      class="j-checkbox"
                    ></b-form-checkbox>
                    <span class="switch-slider"></span>
                  </label>
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>
            </div>
          </b-collapse>
        </section>

        <div class="col-lg-12 col-xl-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="updateUser(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <!-- <button @click.prevent.stop="onResetForm" class="btn-black">{{ $t('reset') }}</button> -->
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="aggregator-users"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import UserService from "@/services/UserService";
  import { error } from "util";
  import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

  const selected = {
    Country: "",
    Gender: "",
    Cinemas: "",
    Role: "",
    State: "",
    City: "",
    Designation: "",
    Departments: "",
    Distributor: "",
    AggregatorType: "",
  };

  export default {
    data() {
      return {
        btenable: false,
        employeementType: ["Contract", "Permanent", "Probation"],
        aggregatorType: ["Website", "Third Party", "Kiosk", "App", "Fnb App"],
        loginRoleId: null,
        editorUser: null,
        affectedUserId: null,
        roleIdUser: null,
        isRoleID: true,
        messagegender: "Please Select Gender.",
        messagecountry: "Please Select Country.",
        messagestate: "Please Select State.",
        messagecity: "Please Select City.",
        messagerole: "Please Select Role.",
        messagedesignation: "Please Select Designation.",
        messagecinema: "Please Select Cinema.",
        messagedepartment: "Please Select Department.",
        messagedistributor: "Please Select Distributor.",

        submitted: false,
        userDetails: {
          username: "",
          first_name: "",
          middle_name: "",
          last_name: "",
          email_id: "",
          country_mob_code: "",
          mobile_no: "",
          cinema_id: "",
          role_id: "",
          password: "",
          zipcode: "",
          aggregator_type: "",
          userpin: "",
          passwordpin: "",
          report_code: "",
          gl_account: "",
          gl_desc: "",
          kitchen_order_seq: "",
          kitchen_color_code: "#0e4e91",
          //userprofileData
          up_employee_code: "",
          up_dob: new Date("1990-01-01"),
          up_doj: null,
          up_address1: "",
          up_alt_contact_no: "",
          // dropdown ids
          designation_id: null,
          gender_id: null,
          city_id: null,
          state_id: null,
          country_id: null,
          department_id: null,
          user_profile_image_url: "",
          is_active: false,
          up_employment_type: "Contract",
          is_internet_handling_fee_applied: "N",
          is_direct_payment_allowed: "N",
        },

        selected: selected,
        flag: {
          isDistributor: false,
        },

        Distributors: [],

        //
        Genres: [],
        GenresMethod: {
          GET: "/admin/",
          tableName: "ms_genre",
          urlKey: "genres",
        },

        Gender: [],
        GenderMethod: {
          GET: "/admin/",
          tableName: "ms_gender",
          urlKey: "gender",
        },

        Countries: [],
        CountriesMethod: {
          GET: "/admin/",
          tableName: "ms_countries",
          urlKey: "countries",
        },

        States: [],
        StatesMethod: {
          GET: "/admin/tablelist/",
          tableName: "ms_states",
          urlKey: "states",
        },

        Cities: [],
        CitiesMethod: {
          GET: "/admin/tablelist/",
          tableName: "ms_cities",
          urlKey: "cities",
        },

        Roles: [],
        RolesMethod: {
          GET: "/admin/",
          tableName: "ms_roles",
          urlKey: "roles",
        },

        Designations: [],
        DesignationsMethods: {
          GET: "/admin/",
          tableName: "ms_designations",
          urlKey: "designations",
        },

        Cinemas: [],
        CinemasMethods: {
          GET: "/admin/",
          tableName: "ms_cinemas",
          urlKey: "cinemas",
        },
        Departments: [],
        DepartmentsMethods: {
          GET: "/admin/",
          tableName: "ms_departments",
          urlKey: "departments",
        },
        user_id: "",
        errmsg: "",
        futuredate: "",
        previousdate: "",
        searchCountry: "",
        CountriesCopy: [],
        searchState: "",
        StatesCopy: [],
        searchCity: "",
        CitiesCopy: [],
        searchCode: "",
        CodeListCopy: [],
        countryList: [],
        SelectedCountryCode: "",
        sectionCollapse: {
          personalDetails: true,
        },
      };
    },
    computed: {
      personalDetails() {
        return this.pesonalform.filter(
          (personal) => personal.personal_type === 1
        );
      },
    },
    beforeMount() {
      const { user_id } = this.$route.query;
      console.log("user_id :", user_id);
      const { role_id } = this.secureStore.get("USINFO");
      this.loginRoleId = role_id;
      this.editorUser = this.secureStore.get("USINFO").user_id;
      // this.editorUser = user_id;
      // console.log(
      //   'window.location.hash.includes("/edit-user?user_id=" + user_id) :',
      //   window.location.hash.includes("/edit-user?user_id=" + user_id)
      // );
      if (user_id == this.editorUser) {
        this.$router.push({
          path: "/access-denied",
        });
      }
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      /////////////////////////////////////////////////////
      this.futuredate = new Date();
      this.futuredate.setDate(this.futuredate.getDate() + 7);
      this.previousdate = new Date();
      this.previousdate.setFullYear(this.previousdate.getFullYear() - 50);
      // console.log("previousdate :", previousdate);
    },
    mounted() {
      const { user_id, role_id } = this.$route.query;
      this.roleIdUser = role_id;

      if (user_id) {
        this.affectedUserId = user_id;
        this.getUserDetailsList(user_id);
      } else {
        this.$router.go(-1);
      }
    },
    computed: {
      showKitchenOrderFields() {
        return this.authorizeClient(CLIENT_NAMES_OBJ.starcinemas);
      },
    },
    methods: {
      onSearchCode() {
        if (this.searchCode && this.searchCode.length > 0) {
          this.countryList = this.CodeListCopy.filter((x) => {
            if (
              x.country_mob_code &&
              x.country_mob_code
                .toLowerCase()
                .includes(this.searchCode.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.countryList = this.CodeListCopy;
        }
      },
      onSearchCountry: function(value) {
        if (this.searchCountry && this.searchCountry.length > 0) {
          this.Countries = this.CountriesCopy.filter((x) => {
            if (
              x.country_name
                .toLowerCase()
                .includes(this.searchCountry.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Countries = this.CountriesCopy;
        }
      },
      onSearchState: function(value) {
        if (this.searchState && this.searchState.length > 0) {
          this.States = this.StatesCopy.filter((x) => {
            if (
              x.state_name
                .toLowerCase()
                .includes(this.searchState.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.States = this.StatesCopy;
        }
      },
      onSearchCity: function(value) {
        if (this.searchCity && this.searchCity.length > 0) {
          this.Cities = this.CitiesCopy.filter((x) => {
            if (
              x.city_name.toLowerCase().includes(this.searchCity.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cities = this.CitiesCopy;
        }
      },
      onSelectEmployeementTypeHandler: function(value) {
        // this.userDetails.employeementSelectedType = value;

        this.userDetails.up_employment_type = value;

        console.log(
          "this.userDetails.employeementSelectedType ",
          this.userDetails.up_employment_type
        );
      },
      clearSelectedDate: function() {
        this.userDetails.up_dob = null;
      },
      cleardoj: function() {
        this.userDetails.up_doj = null;
      },
      onResetForm: function() {
        this.userDetails = {
          username: "",
          first_name: "",
          middle_name: "",
          last_name: "",
          email_id: "",
          country_mob_code: "",
          mobile_no: "",
          cinema_id: 0,
          role_id: 10,
          password: "",
          //userprofileData
          up_employee_code: "",
          up_dob: null,
          up_doj: null,
          up_address1: "",
          up_alt_contact_no: "",
          report_code: "",
          gl_account: "",
          gl_desc: "",
          kitchen_order_seq: "",
          kitchen_color_code: "#0e4e91",
          // dropdown ids
          designation_id: null,
          gender_id: null,
          city_id: null,
          state_id: null,
          country_id: null,
          department_id: null,
          d_id: null,
          user_profile_image_url: "",
          up_employment_type: "Contract",
          is_internet_handling_fee_applied: "N",
          is_direct_payment_allowed: "N",
        };
        this.selected = {
          ...selected,
        };
      },
      onSelectHandler: function(type, value) {
        if (type == "aggregatorType") {
          this.selected.AggregatorType = value;
          this.userDetails.aggregator_type = value;
        } else if (type == "gender") {
          this.selected.Gender = value.gender;
          this.userDetails.gender_id = value.gender_id;
        } else if (type == "country") {
          this.selected.Country = value.country_name;
          this.userDetails.country_id = value.country_id;
          this.userDetails.country_mob_code = value.country_mob_code;
          this.getStatesList(value.country_id, null);
        } else if (type == "state") {
          this.selected.State = value.state_name;
          this.userDetails.state_id = value.state_id;
          this.getCitiesList(value.state_id, null);
        } else if (type == "city") {
          this.selected.City = value.city_name;
          this.userDetails.city_id = value.city_id;
        } else if (type == "role") {
          this.selected.Role = value.role_name;
          this.userDetails.role_id = value.role_id;
          value.role_name === "Distributor"
            ? (this.flag.isDistributor = true)
            : (this.flag.isDistributor = false);
          if (this.flag.isDistributor) {
            this.selected.Cinemas = "";
            //this.selected.Gender = "";
            this.userDetails.gender_id = "";
            this.selected.Designation = "";
            this.selected.Departments = "";
            this.selected.Distributor = "";
            this.userDetails.up_employment_type = "";
            this.userDetails.cinema_id = "";
          }
        } else if (type == "designation") {
          this.selected.Designation = value.designation;
          this.userDetails.designation_id = value.designation_id;
        } else if (type == "cinema") {
          this.selected.Cinemas = value.cine_name;
          this.userDetails.cinema_id = value.cine_id;
        } else if (type == "department") {
          this.selected.Departments = value.dept_name;
          this.userDetails.department_id = value.dept_id;
        } else if (type == "distributor") {
          this.userDetails.d_id = value.d_id;
          this.selected.Distributor = value.d_company_name;
        } else if (type == "countrycode") {
          this.userDetails.country_mob_code = value.country_mob_code;
          this.SelectedCountryCode = value.country_mob_code;
        }
        this.$nextTick(() => {
          this.$validator.reset();
          this.$validator.errors.clear();
          this.$validator.resume();
          // console.log("object R :");
          this.$forceUpdate();
        });
      },
      getUserDetailsList: function(user_id) {
        UserService.GetUserDetails({ user_id })
          .then((response) => {
            const { data } = response;
            console.log("data GetUserDetails s:", data);
            if (data.status && data.data) {
              this.userDetails = {
                ...this.userDetails,
                ...data.data,
              };
              let obj = data.data;
              this.userDetails.is_active = this.userDetails.is_active === "Y";

              //  console.log('this.userDetails.up_employment_type', this.userDetails.up_employment_type);
              //  this.employeementType.map(x => {
              //    if(x == this.this.userDetails.up_employment_type){}

              //  });
              if (obj.aggregator_type == "website") {
                this.userDetails.aggregator_type = "Website";
                this.selected.AggregatorType = "Website";
              } else if (obj.aggregator_type == "thirdparty") {
                this.userDetails.aggregator_type = "Third Party";
                this.selected.AggregatorType = "Third Party";
              } else if (obj.aggregator_type == "kiosk") {
                this.userDetails.aggregator_type = "Kiosk";
                this.selected.AggregatorType = "kiosk";
              } else if (obj.aggregator_type == "App") {
                this.userDetails.aggregator_type = "App";
                this.selected.AggregatorType = "App";
              } else if (obj.aggregator_type == "Fnb App") {
                this.userDetails.aggregator_type = "Fnb App";
                this.selected.AggregatorType = "Fnb App";
              }

              console.log(
                "set value get list user details  ",
                this.userDetails.is_active
              );
              // console.log('before mount ',this.userDetails.is_active == 'Y' ? true:false );
              // console.log('before edit active ',this.userDetails.is_active);
              //  this.userDetails.is_active = this.userDetails.is_active === true ? true : false;
              // console.log('After  edit .is_active=== ',this.userDetails.is_active);
              this.userDetails.up_dob =
                obj.up_dob && isValidDate(new Date(obj.up_dob))
                  ? new Date(obj.up_dob)
                  : null;

              this.userDetails.up_dob && this.userDetails.up_dob.length == 0
                ? (this.userDetails.up_dob = new Date("1990-01-01"))
                : this.userDetails.up_dob;

              this.userDetails.up_doj =
                obj.up_doj && isValidDate(new Date(obj.up_doj))
                  ? new Date(obj.up_doj)
                  : null;
              this.getCountriesList(obj.country_id || null);
              this.getStatesList(obj.country_id || null, obj.state_id || null);
              this.getCitiesList(obj.state_id || null, obj.city_id || null);

              function isValidDate(d) {
                if (Object.prototype.toString.call(d) === "[object Date]") {
                  // it is a date
                  if (isNaN(d.getTime())) {
                    return false;
                    // d.valueOf() could also work
                    // date is not valid
                  } else {
                    return true;
                    // date is valid
                  }
                } else {
                  return false;
                  // not a date
                }
              }
            } else data.message ? this.$toasted.show(data.message) : "";
          })
          .catch(this._CatchError);
      },

      getCountriesList: function(country_id) {
        this.Countries = [];
        let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.Countries = data.Records;
                this.CountriesCopy = data.Records;
                this.CodeListCopy = data.Records;
                this.countryList = data.Records;
                if (country_id) {
                  this.Countries.map((x) => {
                    if (country_id === x.country_id) {
                      this.selected.Country = x.country_name;
                    }
                  });
                }
              }
            } else data.message ? this.$toasted.show(data.message) : "";
          })
          .catch(this._CatchError);
      },
      getStatesList: function(country_id, state_id) {
        this.States = [];
        let body = this.getRequestBody("GET", undefined, {
          ...this.StatesMethod,
          params: { id: "country_id-" + country_id },
        });
        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.States = data.Records;
                this.StatesCopy = data.Records;
                if (state_id) {
                  this.States.map((x) => {
                    if (state_id === x.state_id) {
                      this.selected.State = x.state_name;
                    }
                  });
                }
              }
            } else data.message ? this.$toasted.show(data.message) : "";
          })
          .catch(this._CatchError);
      },
      getCitiesList: function(state_id, city_id) {
        this.Cities = [];
        let body = this.getRequestBody("GET", undefined, {
          ...this.CitiesMethod,
          params: { id: "state_id-" + state_id },
        });
        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.Cities = data.Records;
                this.CitiesCopy = data.Records;
                if (city_id) {
                  this.Cities.map((x) => {
                    if (city_id === x.city_id) {
                      this.selected.City = x.city_name;
                    }
                  });
                }
              }
            } else data.message ? this.$toasted.show(data.message) : "";
          })
          .catch(this._CatchError);
      },

      updateUser: function(flag) {
        this.userDetails.is_active = this.userDetails.is_active;
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          if (valid) {
            if (!this.userDetails.country_mob_code) {
              return;
            }
            if (flag) {
              this.btenable = true;
              UserService.UpdateAUser({
                ...this.userDetails,
                flag: this.flag,
              })
                .then((result) => {
                  this.btenable = false;

                  const { data } = result;
                  if (data.status) {
                    this.$router.go(-1);
                  } else data.message ? this.$toasted.show(data.message) : "";
                })
                .catch(this._CatchError);
            }
          }
        });
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/AggregatorsComponents/editAggregator.vue